export default {"src":"/_next/static/media/konica.679b4b18.svg","height":123,"width":213,"blurWidth":0,"blurHeight":0};